import { Icon } from '@iconify/react';
import React from 'react';

export default function ContactInfoWidget() {
  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        Av. Mitre 3601 - Sarandí 
      </li> 
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
       0800-813-3333 / (011) 7720-8812
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="mdi:whatsapp" />
        </i>
        <a href="https://wa.me/5491170808075" target="_blank" rel="noopener noreferrer">
          11-7080-8075
        </a>
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        informes@formed.com.ar
      </li>
    </ul>
  );
}
